<match-display-wrapper
    matchLabel="{{ l10nKeys.protocolMatchLabel | vtranslate }}"
    matchCriteria="{{ matchCriteria }}"
    [matchValuesExist]="!!editable.matchValue"
>
    {{ editable.matchValue }}
</match-display-wrapper>
